import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Contract Name',
    field: 'contractName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Start Date',
    field: 'contractStartDate',
    filter: 'date',
    searchable: true,
  },
  {
    title: 'End Date',
    field: 'contractEndDate',
    filter: 'date',
    searchable: true,
  },
  {
    title: 'Contract Files',
    field: 'fileName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded By',
    field: 'uploadedByFullName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded On',
    field: 'uploadedOn',
    filter: 'text',
    searchable: true,
  },
];
